var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// source/assets/scripts/add-free-gift.js
var AddFreeGift = class {
  constructor() {
    __publicField(this, "checkCartAndUpdate", (cart, cartTag) => __async(this, null, function* () {
      let freeProductItem = cart.items.find(
        (lineItem) => lineItem.properties["_freeGiftType"] != ""
      );
      if (!freeProductItem) {
        return;
      }
      let removeItems = [];
      let necklaceItemPrice = 0;
      let tag = window.productThresholds.excludeProductTag;
      if (tag != "") {
        for (let index = 0; index < cartTag.items.length; index++) {
          const element = cartTag.items[index];
          if (element.tags.includes(tag)) {
            necklaceItemPrice = necklaceItemPrice + element.item.line_price;
          }
        }
      }
      let eligibleAmount = (cart.total_price - necklaceItemPrice) / 100;
      let freeItemCount = cart.items.filter(
        (lineItem) => lineItem.properties["_freeGiftType"]
      );
      if (freeItemCount.length == 1) {
        let item = cart.items.find(
          (lineItem) => lineItem.properties["_freeGiftType"] == "gift-at-99"
        );
        let item2 = cart.items.find(
          (lineItem) => lineItem.properties["_freeGiftType"] == "free-gift"
        );
        if (eligibleAmount < window.productThresholds.product_threshold_1 && item) {
          if (item) {
            removeItems.push({
              id: item.key,
              quantity: 0
            });
          }
        } else if (eligibleAmount < window.productThresholds.product_threshold_2 && item2) {
          if (item2) {
            removeItems.push({
              id: item2.key,
              quantity: 0
            });
          }
        } else if (freeItemCount.quantity > 1) {
          removeItems.push({
            id: freeProductItem.key,
            quantity: 1
          });
        }
      } else if (freeItemCount.length > 1) {
        if (eligibleAmount > window.productThresholds.product_threshold_1 && eligibleAmount > window.productThresholds.product_threshold_2) {
          let firstIndex = cart.items.find(
            (lineItem) => lineItem.properties["_freeGiftType"] == "gift-at-99"
          );
          removeItems.push({
            id: firstIndex.key,
            quantity: 0
          });
        } else if (eligibleAmount > window.productThresholds.product_threshold_1 && eligibleAmount < window.productThresholds.product_threshold_2) {
          let firstIndex = cart.items.find(
            (lineItem) => lineItem.properties["_freeGiftType"] == "free-gift"
          );
          removeItems.push({
            id: firstIndex.key,
            quantity: 0
          });
        }
      }
      if (removeItems.length > 0) {
        window.loadingItem = false;
        yield this.removeItem(removeItems);
        return;
      }
    }));
    __publicField(this, "removeItem", (items) => __async(this, null, function* () {
      if (items.length > 0) {
        let item = items.pop();
        try {
          const response = yield fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(__spreadProps(__spreadValues({}, item), {
              sections: [
                "mini-cart",
                "mobile-cart-icon-bubble",
                "cart-icon-bubble"
              ]
            }))
          });
          const data = yield response.json();
          if (items.length > 0) {
            this.removeItem(items);
          }
          const parsedState = data;
          document.querySelector("mini-cart") && document.querySelector("mini-cart").renderContents(parsedState);
          if (item.length == 0) {
          }
        } catch (error) {
          console.error("Error removing product:", error);
        }
      }
    }));
    __publicField(this, "init", () => __async(this, null, function* () {
      if (!window.loadingItem) {
        window.loadingItem = true;
        try {
          const res = yield fetch("/cart.json");
          const cart = yield res.json();
          const tagRes = yield fetch("/cart?view=tags");
          const cartTag = yield tagRes.json();
          const update = yield this.checkCartAndUpdate(cart, cartTag);
          window.loadingItem = false;
        } catch (e) {
          console.log("error", e);
          window.loadingItem = false;
          return false;
        }
      }
    }));
    this.init();
  }
};
window.freeGiftPromo = new AddFreeGift();
window.freeGiftPromo.init();
//# sourceMappingURL=add-free-gift.js.map
